export const entityPermissionSubjects = {
	absences: 'absences',
	colorDefinitions: 'colorDefinitions',
	contactCodes: 'contactCodes',
	contactCodeTrees: 'contactCodeTrees',
	customPages: 'customPages',
	customProperties: 'customProperties',
	pauseReasons: 'pauseReasons',
	permissions: 'permissions',
	queues: 'queues',
	roles: 'roles',
	ruleSets: 'ruleSets',
	settings: 'settings',
	skillGroups: 'skillGroups',
	skills: 'skills',
	teams: 'teams',
	templates: 'templates',
	userGroups: 'userGroups',
	users: 'users',
} as const

export const tabPermissionSubjects = {
	absences: {
		detail: 'absences_detail',
	},
	colorDefinitions: {
		detail: 'colorDefinitions_detail',
	},
	contactCodes: {
		detail: 'contactCodes_detail',
	},
	contactCodeTrees: {
		detail: 'contactCodeTrees_detail',
	},
	customPages: {
		detail: 'customPages_detail',
		teams: 'teams_customPages',
		users: 'users_customPages',
	},
	customProperties: {
		detail: 'customProperties_detail',
		ruleSets: 'customProperties_ruleSets',
	},
	pauseReasons: {
		detail: 'pauseReasons_detail',
		teams: 'teams_pauseReasons',
		users: 'users_pauseReasons',
	},
	permissions: {
		detail: 'permissions_detail',
		roles: 'roles_permissions',
	},
	queues: {
		detail: 'queues_detail',
		contactCodeTrees: 'queues_contactCodeTrees',
		teams: 'teams_queues',
		users: 'users_queues',
	},
	roles: {
		detail: 'roles_detail',
		permissions: 'roles_permissions',
		users: 'users_roles',
	},
	ruleSets: {
		detail: 'ruleSets_detail',
		customProperties: 'customProperties_ruleSets',
	},
	skillGroups: {
		detail: 'skillGroups_detail',
		skills: 'skillGroups_skills',
		teams: 'teams_skillGroups',
		users: 'users_skillGroups',
	},
	skills: {
		detail: 'skills_detail',
		skillGroups: 'skillGroups_skills',
		teams: 'teams_skills',
		users: 'users_skills',
	},
	teams: {
		detail: 'teams_detail',
		customPages: 'teams_customPages',
		pauseReasons: 'teams_pauseReasons',
		queues: 'teams_queues',
		skillGroups: 'teams_skillGroups',
		skills: 'teams_skills',
		templates: 'templates_teams',
		users: 'teams_users',
		settings: 'teams_settings',
	},
	templates: {
		detail: 'templates_detail',
		customPages: 'templates_customPages',
		queues: 'templates_queues',
		roles: 'templates_roles',
		skills: 'templates_skills',
		teams: 'templates_teams',
		settings: 'templates_settings',
	},
	userGroups: {
		detail: 'userGroups_detail',
	},
	users: {
		detail: 'users_detail',
		customPages: 'users_customPages',
		pauseReasons: 'users_pauseReasons',
		queues: 'users_queues',
		roles: 'users_roles',
		skillGroups: 'users_skillGroups',
		skills: 'users_skills',
		teams: 'teams_users',
		templates: 'users_templates',
		settings: 'users_settings',
	},
} as const

export const permissionSubjectByToken = {
	ABSENCEDETAIL: 'absences_detail',
	ABSENCES: 'absences',
	ABSENCESDETAIL: 'absences_detail',
	COLORDEFINITIONDETAIL: 'colorDefinitions_detail',
	COLORDEFINITIONS: 'colorDefinitions',
	COLORDEFINITIONSDETAIL: 'colorDefinitions_detail',
	CONTACTCODEDETAIL: 'contactCodes_detail',
	CONTACTCODES: 'contactCodes',
	CONTACTCODESDETAIL: 'contactCodes_detail',
	CONTACTCODETREEDETAIL: 'contactCodeTrees_detail',
	CONTACTCODETREES: 'contactCodeTrees',
	CONTACTCODETREESDETAIL: 'contactCodeTrees_detail',
	CUSTOMPAGEDETAIL: 'customPages_detail',
	CUSTOMPAGES: 'customPages',
	CUSTOMPAGESDETAIL: 'customPages_detail',
	CUSTOMPROPERTIES: 'customProperties',
	CUSTOMPROPERTIESDETAIL: 'customProperties_detail',
	CUSTOMPROPERTIESRULES: 'customProperties_ruleSets',
	CUSTOMPROPERTYDETAIL: 'customProperties_detail',
	CUSTOMPROPERTYRULES: 'customProperties_ruleSets',
	PAUSEREASONDETAIL: 'pauseReasons_detail',
	PAUSEREASONS: 'pauseReasons',
	PAUSEREASONSDETAIL: 'pauseReasons_detail',
	PERMISSIONDETAIL: 'permissions_detail',
	PERMISSIONS: 'permissions',
	PERMISSIONSDETAIL: 'permissions_detail',
	QUEUECONTACTCODETREES: 'queues_contactCodeTrees',
	QUEUEDETAIL: 'queues_detail',
	QUEUES: 'queues',
	QUEUESCONTACTCODETREES: 'queues_contactCodeTrees',
	QUEUESDETAIL: 'queues_detail',
	ROLEDETAIL: 'roles_detail',
	ROLEPERMISSIONS: 'roles_permissions',
	ROLES: 'roles',
	ROLESDETAIL: 'roles_detail',
	ROLESPERMISSIONS: 'roles_permissions',
	RULEDETAIL: 'ruleSets_detail',
	RULES: 'ruleSets',
	RULESDETAIL: 'ruleSets_detail',
	SETTINGS: 'settings',
	SKILLDETAIL: 'skills_detail',
	SKILLGROUPDETAIL: 'skillGroups_detail',
	SKILLGROUPS: 'skillGroups',
	SKILLGROUPSDETAIL: 'skillGroups_detail',
	SKILLGROUPSKILLS: 'skillGroups_skills',
	SKILLGROUPSSKILLS: 'skillGroups_skills',
	SKILLS: 'skills',
	SKILLSDETAIL: 'skills_detail',
	TEAMCUSTOMPAGES: 'teams_customPages',
	TEAMDETAIL: 'teams_detail',
	TEAMPAUSEREASONS: 'teams_pauseReasons',
	TEAMQUEUES: 'teams_queues',
	TEAMS: 'teams',
	TEAMSCUSTOMPAGES: 'teams_customPages',
	TEAMSDETAIL: 'teams_detail',
	TEAMSETTINGS: 'teams_settings',
	TEAMSKILLGROUPS: 'teams_skillGroups',
	TEAMSKILLS: 'teams_skills',
	TEAMSPAUSEREASONS: 'teams_pauseReasons',
	TEAMSQUEUES: 'teams_queues',
	TEAMSSETTINGS: 'teams_settings',
	TEAMSSKILLGROUPS: 'teams_skillGroups',
	TEAMSSKILLS: 'teams_skills',
	TEAMSUSERS: 'teams_users',
	TEAMUSERS: 'teams_users',
	TEMPLATECUSTOMPAGES: 'templates_customPages',
	TEMPLATEDETAIL: 'templates_detail',
	TEMPLATEQUEUES: 'templates_queues',
	TEMPLATEROLES: 'templates_roles',
	TEMPLATES: 'templates',
	TEMPLATESCUSTOMPAGES: 'templates_customPages',
	TEMPLATESDETAIL: 'templates_detail',
	TEMPLATESETTINGS: 'templates_settings',
	TEMPLATESKILLS: 'templates_skills',
	TEMPLATESQUEUES: 'templates_queues',
	TEMPLATESROLES: 'templates_roles',
	TEMPLATESSETTINGS: 'templates_settings',
	TEMPLATESSKILLS: 'templates_skills',
	TEMPLATESTEAMS: 'templates_teams',
	TEMPLATETEAMS: 'templates_teams',
	USERCUSTOMPAGES: 'users_customPages',
	USERDETAIL: 'users_detail',
	USERGROUPDETAIL: 'userGroups_detail',
	USERGROUPS: 'userGroups',
	USERGROUPSDETAIL: 'userGroups_detail',
	USERPAUSEREASONS: 'users_pauseReasons',
	USERQUEUES: 'users_queues',
	USERROLES: 'users_roles',
	USERS: 'users',
	USERSCUSTOMPAGES: 'users_customPages',
	USERSDETAIL: 'users_detail',
	USERSETTINGS: 'users_settings',
	USERSKILLGROUPS: 'users_skillGroups',
	USERSKILLS: 'users_skills',
	USERSPAUSEREASONS: 'users_pauseReasons',
	USERSQUEUES: 'users_queues',
	USERSROLES: 'users_roles',
	USERSSETTINGS: 'users_settings',
	USERSSKILLGROUPS: 'users_skillGroups',
	USERSSKILLS: 'users_skills',
	USERSTEMPLATES: 'users_templates',
	USERTEMPLATES: 'users_templates',
} as const

export type PermissionSubject =
	| (typeof entityPermissionSubjects)[keyof typeof entityPermissionSubjects]
	| string

export function normalizePermissionSubjectToken(token: string): string {
	return token.replaceAll(/[^A-Za-z0-9]/g, '').toUpperCase()
}

export function getPermissionSubjectForToken(
	token: string,
): PermissionSubject | undefined {
	return (permissionSubjectByToken as Record<string, PermissionSubject>)[
		normalizePermissionSubjectToken(token)
	]
}

export function getPermissionSubjectForEntity(
	entity: string,
): PermissionSubject | undefined {
	return (entityPermissionSubjects as Record<string, PermissionSubject>)[entity]
}

export function getPermissionSubjectForEntityTab(
	entity: string,
	tab: string,
): PermissionSubject | undefined {
	const normalizedTab = tab === 'overview' ? 'detail' : tab
	return (
		tabPermissionSubjects as Record<string, Record<string, PermissionSubject>>
	)[entity]?.[normalizedTab]
}
